import React from 'react';
import Select from '../../components/Select/Select';
import styles from './stockReport.module.css';

const StockReportFilters = ({
  markOptions,
  modelOptions,
  cityOptions,
  dcOptions,
  selectedMarks,
  selectedModels,
  selectedCities,
  selectedDcs,
  onMarksChange,
  onModelsChange,
  onCitiesChange,
  onDcsChange,
  disabled,
}) => {
  return (
    <div className={styles.filters}>
      <div className={styles.filterItem}>
        <Select
          title="Марка"
          placeholder="Все марки"
          options={markOptions}
          value={selectedMarks}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onMarksChange}
        />
      </div>
      <div className={styles.filterItem}>
        <Select
          title="Модель"
          placeholder="Все модели"
          options={modelOptions}
          value={selectedModels}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onModelsChange}
        />
      </div>
      <div className={styles.filterItem}>
        <Select
          title="Город"
          placeholder="Все города"
          options={cityOptions}
          value={selectedCities}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onCitiesChange}
        />
      </div>
      <div className={styles.filterItem}>
        <Select
          title="Дилерский центр"
          placeholder="Все ДЦ"
          options={dcOptions}
          value={selectedDcs}
          isMulti
          isSearchable
          disabled={disabled}
          onChange={onDcsChange}
        />
      </div>
    </div>
  );
};

export default StockReportFilters;
